import React, { useEffect, useState } from 'react';
import { posConfig, posConfigSet } from '../services/api';

// Configuración del POS → Cobro por QR (SnelPay). Vive en Sistema porque es un
// ajuste de administración (clave CIF del comercio), no una acción de caja.
export default function PosConfig() {
  const [configurado, setConfigurado] = useState(false);
  const [clave, setClave] = useState('');
  const [incluyeIva, setIncluyeIva] = useState(false);
  const [pinConfig, setPinConfig] = useState(false);
  const [cajeroEdita, setCajeroEdita] = useState(false);
  const [pin, setPin] = useState('');
  const [busy, setBusy] = useState(false);
  const [flash, setFlash] = useState(null);
  const aviso = (ok, t) => { setFlash({ ok, t }); setTimeout(() => setFlash(null), 4000); };

  const cargar = () => posConfig().then(r => {
    setConfigurado(!!r.data.snelpay_configurado); setIncluyeIva(!!r.data.precios_incluyen_iva);
    setPinConfig(!!r.data.supervisor_pin_configurado); setCajeroEdita(!!r.data.cajero_edita_cantidad);
  }).catch(() => {});
  useEffect(() => { cargar(); }, []);

  const toggleIva = async (val) => {
    setIncluyeIva(val);
    try { await posConfigSet({ precios_incluyen_iva: val }); aviso(true, val ? 'Los precios se tratan como IVA incluido' : 'Los precios se tratan como base + IVA'); }
    catch (e) { setIncluyeIva(!val); aviso(false, '❌ ' + (e.response?.data?.error || 'No se pudo guardar')); }
  };
  const toggleCajeroEdita = async (val) => {
    setCajeroEdita(val);
    try { await posConfigSet({ cajero_edita_cantidad: val }); aviso(true, val ? 'El cajero puede editar cantidades libremente' : 'Editar cantidades requiere PIN de supervisor'); }
    catch (e) { setCajeroEdita(!val); aviso(false, '❌ ' + (e.response?.data?.error || 'No se pudo guardar')); }
  };
  const guardarPin = async () => {
    if (!/^\d{4,6}$/.test(pin)) { aviso(false, 'El PIN debe ser de 4 a 6 dígitos'); return; }
    setBusy(true);
    try { await posConfigSet({ supervisor_pin: pin }); setPin(''); aviso(true, '✅ PIN de supervisor guardado'); cargar(); }
    catch (e) { aviso(false, '❌ ' + (e.response?.data?.error || 'No se pudo guardar')); }
    finally { setBusy(false); }
  };
  const borrarPin = async () => {
    setBusy(true);
    try { await posConfigSet({ borrar_pin: true }); aviso(true, 'PIN de supervisor eliminado'); cargar(); }
    catch (e) { aviso(false, '❌ ' + (e.response?.data?.error || 'No se pudo eliminar')); }
    finally { setBusy(false); }
  };

  const guardar = async () => {
    if (!clave.trim()) return;
    setBusy(true);
    try { await posConfigSet({ snelpay_clave_cif: clave.trim() }); setClave(''); aviso(true, '✅ Clave de SnelPay guardada'); cargar(); }
    catch (e) { aviso(false, '❌ ' + (e.response?.data?.error || 'No se pudo guardar')); }
    finally { setBusy(false); }
  };
  const borrar = async () => {
    setBusy(true);
    try { await posConfigSet({ borrar: true }); aviso(true, 'Clave de SnelPay eliminada'); cargar(); }
    catch (e) { aviso(false, '❌ ' + (e.response?.data?.error || 'No se pudo eliminar')); }
    finally { setBusy(false); }
  };

  return (
    <div>
      <div style={s.pageHeader}>
        <div><h1 style={s.h1}>Configuración del POS</h1><p style={s.sub}>Precios y cobro por QR del Punto de Venta</p></div>
      </div>
      {flash && <div style={{ ...s.flash, background: flash.ok ? '#064e3b' : '#3f1d1d', color: flash.ok ? '#6ee7b7' : '#fca5a5' }}>{flash.t}</div>}

      <div style={{ ...s.card, maxWidth: 560, marginBottom: 14 }}>
        <h3 style={{ color: '#f1f5f9', fontSize: 15, fontWeight: 700, margin: '0 0 4px' }}>Precios</h3>
        <label style={{ display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer', marginTop: 10 }}>
          <input type="checkbox" checked={incluyeIva} onChange={e => toggleIva(e.target.checked)} />
          <span style={{ color: '#e2e8f0', fontSize: 14 }}>Los precios de los productos ya incluyen IVA</span>
        </label>
        <p style={{ ...s.sub, marginTop: 8 }}>
          {incluyeIva
            ? 'El precio que registras es el total que paga el cliente; la base y el IVA se calculan hacia atrás para la factura.'
            : 'El precio es la base y el POS le suma el IVA (ej. $8.000 + 19% = $9.520).'}
        </p>
      </div>

      <div style={{ ...s.card, maxWidth: 560, marginBottom: 14 }}>
        <h3 style={{ color: '#f1f5f9', fontSize: 15, fontWeight: 700, margin: '0 0 4px' }}>Seguridad</h3>
        <label style={{ display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer', marginTop: 10 }}>
          <input type="checkbox" checked={cajeroEdita} onChange={e => toggleCajeroEdita(e.target.checked)} />
          <span style={{ color: '#e2e8f0', fontSize: 14 }}>Permitir que el cajero edite cantidades libremente</span>
        </label>
        <p style={{ ...s.sub, marginTop: 8 }}>
          {cajeroEdita
            ? 'El cajero puede cambiar cantidades, descuentos y anular líneas sin autorización.'
            : 'Editar cantidad/descuento o anular una línea pide PIN de supervisor (el admin no lo necesita).'}
        </p>
        {!cajeroEdita && <>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, margin: '12px 0 8px' }}>
            <span style={{ width: 9, height: 9, borderRadius: '50%', background: pinConfig ? '#22c55e' : '#64748b', display: 'inline-block' }} />
            <span style={{ color: pinConfig ? '#6ee7b7' : '#94a3b8', fontSize: 13, fontWeight: 600 }}>{pinConfig ? 'PIN de supervisor configurado' : 'Sin PIN de supervisor'}</span>
          </div>
          <div style={{ display: 'flex', gap: 10 }}>
            <input type="password" inputMode="numeric" maxLength={6} style={{ ...s.in, flex: 1 }} placeholder={pinConfig ? 'Nuevo PIN (4-6 dígitos)' : 'PIN (4-6 dígitos)'} value={pin} onChange={e => setPin(e.target.value.replace(/\D/g, ''))} onKeyDown={e => { if (e.key === 'Enter') guardarPin(); }} />
            <button style={s.btnPrimary} disabled={busy || !pin} onClick={guardarPin}>Guardar PIN</button>
            {pinConfig && <button style={{ ...s.btnGhost, color: '#fca5a5', borderColor: '#7f1d1d' }} disabled={busy} onClick={borrarPin}>Quitar</button>}
          </div>
        </>}
      </div>

      <div style={{ ...s.card, maxWidth: 560 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 14 }}>
          <span style={{ width: 9, height: 9, borderRadius: '50%', background: configurado ? '#22c55e' : '#64748b', display: 'inline-block' }} />
          <span style={{ color: configurado ? '#6ee7b7' : '#94a3b8', fontSize: 13, fontWeight: 600 }}>
            {configurado ? 'SnelPay configurado — el POS puede cobrar por QR' : 'Sin configurar — el POS no genera QR'}
          </span>
        </div>
        <p style={s.sub}>Pega la clave CIF de tu comercio en SnelPay. Se guarda cifrada en el servidor. {configurado ? 'Ya hay una clave; escribe una nueva solo si quieres reemplazarla.' : ''}</p>
        <input type="password" style={{ ...s.in, margin: '14px 0' }} placeholder={configurado ? '•••••••• (guardada)' : 'Clave CIF de SnelPay'}
          value={clave} onChange={e => setClave(e.target.value)} onKeyDown={e => { if (e.key === 'Enter') guardar(); }} />
        <div style={{ display: 'flex', gap: 10 }}>
          <button style={{ ...s.btnPrimary, flex: 1 }} disabled={busy || !clave.trim()} onClick={guardar}>{busy ? 'Guardando…' : 'Guardar clave'}</button>
          {configurado && <button style={{ ...s.btnGhost, color: '#fca5a5', borderColor: '#7f1d1d' }} disabled={busy} onClick={borrar}>Eliminar</button>}
        </div>
      </div>
    </div>
  );
}

const s = {
  pageHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 14 },
  h1: { color: '#f1f5f9', fontSize: 24, fontWeight: 700, margin: '0 0 4px' },
  sub: { color: '#64748b', fontSize: 14, margin: 0 },
  card: { background: '#1e293b', border: '1px solid #334155', borderRadius: 12, padding: 20 },
  in: { width: '100%', boxSizing: 'border-box', background: '#0f172a', border: '1px solid #334155', borderRadius: 8, padding: '10px 12px', color: '#f1f5f9', fontSize: 14 },
  btnPrimary: { background: '#1d4ed8', color: '#fff', border: 'none', borderRadius: 10, padding: '11px 18px', fontSize: 14, fontWeight: 700, cursor: 'pointer' },
  btnGhost: { background: 'transparent', color: '#94a3b8', border: '1px solid #334155', borderRadius: 8, padding: '10px 16px', fontSize: 13, cursor: 'pointer' },
  flash: { padding: '10px 14px', borderRadius: 8, fontSize: 13, marginBottom: 12 },
};
